module.exports = __webpack_public_path__ + "static/GlitchlessSonyax45-10f432ef6f24e8c12fb9b1dd26035ece.png";